import { render } from "./AddReportUser.vue?vue&type=template&id=6cc72da8"
import script from "./AddReportUser.vue?vue&type=script&lang=js"
export * from "./AddReportUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__